const ACTION_TYPES = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  VIEW: "view",
};

export default ACTION_TYPES;
